module.exports = require("@mario-kart/domain").InputValidation;
